import { tokenStorage } from '../utils/storage';

export const SecureStorageService = {
  async setAccessToken(token) {
    await tokenStorage.setItem('accessToken', token);
  },
  async getAccessToken() {
    return await tokenStorage.getItem('accessToken');
  },
  async setRefreshToken(token) {
    await tokenStorage.setItem('refreshToken', token);
  },
  async getRefreshToken() {
    return await tokenStorage.getItem('refreshToken');
  },
  async setUserInfo(user) {
    await tokenStorage.setItem('user', JSON.stringify(user));
  },
  async getUserInfo() {
    const user = await tokenStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
  async clearAll() {
    await tokenStorage.clear();
  }
};
